var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_573_68174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4565,
    cy: 11.2982,
    rx: 10.5737,
    ry: 10.6263,
    fill: "black",
    fillOpacity: 0.52
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6826 15.5743H8.80777C8.15861 15.5743 7.63281 15.0459 7.63281 14.3935V8.48941C7.63281 7.83701 8.15861 7.30859 8.80777 7.30859H14.6826C15.3317 7.30859 15.8575 7.83701 15.8575 8.48941V14.3935C15.8575 15.0459 15.3317 15.5743 14.6826 15.5743Z",
    fill: "#EB4E3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_573_68174",
    x: -29.1144,
    y: -29.3253,
    width: 81.1429,
    height: 81.2469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.9986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_573_68174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_573_68174",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.070c65ef3a31ab56bb73a39c01937cc0.svg";
export { ForwardRef as ReactComponent };